// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__9V_QG","loading":"Skeleton_loading__I1b2m"};